import { ComponentView, DelegatedObservableArrayChangeListenner, ObservableArray, ObservableArrayChangeListenner, View, ViewGenerator, ViewModel } from "binder"
import { headerContainer, itemContainer, MultiSelectComboBoxViewModel } from "./multiSelectComboBox-viewModel"

export class MultiSelectComboBoxView extends ComponentView<MultiSelectComboBoxViewModel>{
    GetViewUniqueId(): string {
        return "V-3A10FED0-F674-412D-AC47-CBBDBEAAC948"
    }
    loadHtml(): string {
        let element = require('./multiSelectComboBox.html').default;
        let style = require('./multiSelectComboBox.less');
        return element;
    }
    constructor() {
       super();
    }
    private _itemsChangeListenner:ObservableArrayChangeListenner;
    private _selectedItemsChangeListenner:ObservableArrayChangeListenner;

    public set itemsWithContainer(v: ObservableArray<itemContainer>) { 
        if(this.itemsWithContainer){
            this.itemsWithContainer.removeChangeListenner(this._itemsChangeListenner);
        }
        this._itemsWithContainer = v; 
        if(this.itemsWithContainer){
            this._itemsChangeListenner = new DelegatedObservableArrayChangeListenner(this,()=>this.updateItemsTemplateSelectors());
            this.itemsWithContainer.addChangeListenner(this._itemsChangeListenner)
            this.updateItemsTemplateSelectors();
        }
    } public get itemsWithContainer(): ObservableArray<itemContainer> { return this._itemsWithContainer;} private _itemsWithContainer: ObservableArray<itemContainer>;
    public set selectedItemsWithContainer(v: ObservableArray<headerContainer>) { 
        if(this.selectedItemsWithContainer){
            this.selectedItemsWithContainer.removeChangeListenner(this._selectedItemsChangeListenner);
        }
        this._selectedItemsWithContainer = v; 
        if(this.selectedItemsWithContainer){
            this._selectedItemsChangeListenner = new DelegatedObservableArrayChangeListenner(this,()=>this.selectedItemsTemplateSelectors());
            this.selectedItemsWithContainer.addChangeListenner(this._selectedItemsChangeListenner)
            this.selectedItemsTemplateSelectors();
        }

    } public get selectedItemsWithContainer(): ObservableArray<headerContainer> { return this._selectedItemsWithContainer;} private _selectedItemsWithContainer: ObservableArray<headerContainer>;
    public set isShowingPopup(v: boolean) { 
        this._isShowingPopup = v;
        if(v)
            this.preferredWidth = this.firstlevelElement.clientWidth.toString()+"px";
    } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set preferredWidth(v: string) { this._preferredWidth = v; } public get preferredWidth(): string { return this._preferredWidth;} private _preferredWidth: string;
    
   
    private itemTemplate : Node;
    private headerTemplate : Node;

    templateSelector(vm:ViewModel){
        let newNode = ViewGenerator.GetNodeByTemplate(vm,this.itemTemplate);
        return newNode;
    }
    headertemplateSelector(vm:ViewModel){
        let newNode = ViewGenerator.GetNodeByTemplate(vm,this.headerTemplate);
        return newNode;
    }

    updateItemsTemplateSelectors(): void {
        this.itemsWithContainer.forEach(x=>{
            if((<any>x).templateSelector==null){
                (<any>x).templateSelector = this.templateSelector.bind(this);
                (<any>x).headertemplateSelector = this.headertemplateSelector.bind(this);
            }
        });
    }
    selectedItemsTemplateSelectors(): void {
        this.selectedItemsWithContainer.forEach(x=>{
            if((<any>x).templateSelector==null){
                (<any>x).templateSelector = this.templateSelector.bind(this);
                (<any>x).headertemplateSelector = this.headertemplateSelector.bind(this);
            }
        });
    }
    append(...nodes: (Node | string)[]): void{
        nodes.forEach(node=>{
            if(node instanceof HTMLElement && node.classList.contains("header-template")){
                this.headerTemplate = super.removeAsTemplate(node);
            }else if(node instanceof HTMLElement && node.classList.contains("template")){
                this.itemTemplate = super.removeAsTemplate(node);
            }else{
                this.firstlevelElement.append(node);
            }
        })
    }
}
